__webpack_require__.p = "https://boluo-web.cdn.boluoapp.com/project/boluo/boluo_website/prod/20260127173118/";